/**
 * ── LEGACY SHELL — SCHEDULED FOR DELETION ──────────────────────────────────
 *
 * The original two-factor screen, restored verbatim from `frontend_refactor`
 * (it was .js there; typed only where TS required it).
 *
 * Deliberately NOT modernised: the code is still sent behind an "Email OTP"
 * button rather than on arrival, and it is one plain field. Do not tidy it.
 */
import { Grid, Typography, TextField, Button } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../hooks/hooks";
import {
  reset,
  setLoggedIn,
  logout,
} from "../../../../store/features/authentication/authenticationSlice";
import {
  generateTwoFactor,
  verifyTwoFactor,
} from "../../../../store/thunks/authenticationThunk";

const LegacyTwoFactor = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state: any) => state.authentication);
  const [otp, setOtp] = useState("");

  const [showOtp, setShowOtp] = useState(false);
  const [otpError, setOtpError] = useState(false);
  const [otpErrorMessage, setOtpErrorMessage] = useState("");

  const handleGenerateTwoFactor = () => {
    dispatch(reset());
    if (user && user?.user_name) {
      dispatch(
        generateTwoFactor({
          email: user.user_name,
          name: `${user.first_name}, ${user.last_name}`,
        })
      ).then((generateTwoFactorResult: any) => {
        if (generateTwoFactorResult.payload.result) {
          setShowOtp(true);
        } else {
          setOtpError(true);
          setOtpErrorMessage(generateTwoFactorResult.payload.message);
        }
      });
    } else {
      dispatch(logout());
      navigate("/login");
    }
  };

  const handleVerifyOTP = () => {
    dispatch(
      verifyTwoFactor({ otp, user_index: user.client_user_index })
    ).then((verifyTwoFactorResult: any) => {
      if (verifyTwoFactorResult.payload.result) {
        dispatch(setLoggedIn(true));
        navigate("/dashboard");
      } else {
        setOtp("");
        setOtpError(true);
        setOtpErrorMessage(verifyTwoFactorResult.payload.message);
      }
    });
  };

  return (
    <Grid>
      <Grid
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "80vh",
        }}
      >
        <Grid sx={{ padding: "10px" }}>
          <Typography variant="h4">Two Factor Authentication</Typography>
        </Grid>
        <Grid
          sx={{ display: "flex", justifyContent: "center", padding: "10px" }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleGenerateTwoFactor}
          >
            Email OTP
          </Button>
        </Grid>
        {showOtp && (
          <Grid>
            <Grid
              sx={{
                padding: "10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <TextField
                type="text"
                placeholder="Enter OTP"
                onChange={(e) => setOtp(e.target.value)}
                value={otp}
              />
            </Grid>
            <Grid
              sx={{
                display: "flex",
                justifyContent: "center",
                padding: "10px",
              }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={handleVerifyOTP}
                disabled={otp.length !== 6}
              >
                Verify OTP
              </Button>
            </Grid>
          </Grid>
        )}
        {otpError && (
          <Typography sx={{ color: "red", fontSize: "16px" }}>
            {otpErrorMessage}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default LegacyTwoFactor;
